import {
  APP_BACKGROUND_COLOR,
  BORDER_COLOR,
  SKIP_BUTTON_BACKGROUND_COLOR,
  SKIP_BUTTON_TEXT_COLOR,
} from "../../theme";

export const modalStyle = {
  position: "absolute",
  marginLeft: "40px",
  display: "flex",
  justifyContent: "center",
  backgroundColor: APP_BACKGROUND_COLOR,
  padding: "10px",
  border: `1px solid ${BORDER_COLOR}`,
  borderRadius: "8px",
  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
  zIndex: 1000,
  height: "400px",
  maxHeight: "400px",
  overflowY: "scroll",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  "@media (max-width: 600px)": {
    marginLeft: -25,
    marginTop: "15px"
  },
};

export const styles = {
  container: {
    padding: "10px",
    backgroundColor: APP_BACKGROUND_COLOR,
    border: `1px solid ${BORDER_COLOR}`,
    marginTop: "10px",
    borderRadius: "15px",
    maxWidth: "368px",
  } as const,
  actionContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  } as const,
  allEventsContainer: {
    minWidth: "300px",
    overflowY: "scroll",
    scrollbarWidth: "none",

    "&::-webkit-scrollbar": {
      display: "none",
    },
  } as const,
  skipButton: {
    borderRadius: "var(--radius-md, 8px)",
    background: SKIP_BUTTON_BACKGROUND_COLOR,
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    color: SKIP_BUTTON_TEXT_COLOR,
    textTransform: "none",
  } as const,
  dateContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  } as const,
};
